import React from "react";
import AnimatedPage from "../AnimatedPage";

const Eservices = () => {
  return (
    <AnimatedPage>
      <div className="iframe__ctn">
        <iframe
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          title="Site tan.fr"
          src="https://eservices.nantesmetropole.fr/transports-en-commun"
        ></iframe>
      </div>
    </AnimatedPage>
  );
};

export default Eservices;
